{
  "CHEMISTRY": [
    "skc",
    "mrv",
    "cxsmiles",
    "cxsmarts",
    "cdx",
    "cdxml",
    "csrdf",
    "cml",
    "csmol",
    "cssdf",
    "csrxn",
    "mol",
    "mol2",
    "pdb",
    "rxn",
    "rdf",
    "smiles",
    "smarts",
    "sdf",
    "inchi"
  ],
  "DNA": ["fa", "gb", "gbk", "fasta", "fa", "dna", "seq", "sbd", "embl", "ab1"],
  "AUDIO": ["mp3", "wav", "wma"],
  "VIDEO": ["avi", "flv", "m4v", "mov", "mp4", "mpg", "wmv"],
  "IMAGES": ["bmp", "gif", "jpg", "jpeg", "png", "svg", "tif"],
  "DOCUMENTS": ["doc", "docx", "odt", "rtf", "txt", "text", "md"],
  "SPREADSHEET": ["ods", "xls", "xlsx"],
  "PRESENTATION": ["odp", "pps", "ppt", "pptx"],
  "HTML": ["html", "htm"],
  "CSV": ["csv"],
  "PDF": ["pdf"],
  "XML": ["xml"],
  "ZIP": ["zip"]
}
